import { Button } from "@mui/base";
import { InlineButtonWithInteractiveStyles, OctagonButton } from "../buttons";
import { CustomButtonProps } from "@/types/components";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  type,
  width,
  height,
  backgroundColor,
  marginX,
  marginY,
  onClick,
  borderColor,
  marginLeft,
  toBeResponsive,
}) => {
  // TO DO: check the height of the svg and the height of the buttonm for variants
  // const getSvgHeight = (): string => {
  //   const newHeight = parseInt(height.replace("px", ""));
  //   if (
  //     width === "80px" ||
  //     width === "225px" ||
  //     width === "160px" ||
  //     width === "30px"
  //   ) {
  //     return newHeight + "px".toString();
  //   } else if (width === "165px" || width === "400px") {
  //     return newHeight + 2 + "px".toString();
  //   }
  //   return newHeight + 4 + "px".toString();
  // };
  //
  // const getSvgMargin = (): string => {
  //   if (
  //     width === "80px" ||
  //     width === "225px" ||
  //     width === "160px" ||
  //     width === "30px"
  //   ) {
  //     return "0px";
  //   } else if (width === "165px" || width === "400px") {
  //     return "-1px";
  //   } else {
  //     return "-2px";
  //   }
  // };

  return (
    <InlineButtonWithInteractiveStyles
      className={toBeResponsive ? "whitoutMarginDiv" : ""}
      style={{ marginLeft: marginLeft && marginLeft }}
      onClick={onClick}
      width={`calc(${width} - 32px)`}
      height={height}
      type={type}
      backgroundColor={backgroundColor}
      marginX={marginX}
      marginY={marginY}
    >
      <svg
        className="styled-custom-button-element"
        style={{
          height:
            borderColor == NEUTRO_TITLES_COLOR ? height : (
              `calc(${height} + 1px)`
            ),
          marginTop: borderColor == NEUTRO_TITLES_COLOR ? "0px" : "-0.5px",
          fill: backgroundColor,
          stroke: borderColor && borderColor,
          marginRight: "-1px",
        }}
        viewBox="0 0 15.763361 60"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M 10.980102,57.223922 2.718592,49.06372 C 1.2981288,47.660664 0.49909699,45.750503 0.49909699,43.75785 V 16.242088 c 0,-1.992653 0.79903181,-3.902814 2.21949501,-5.305871 l 8.26151,-8.1602509 C 12.384863,1.388372 16.261408,0.60981187 16.261408,0.60981187 l -0.129301,31.06875413 0.129301,27.71156 c 0,0 -3.876545,-0.778591 -5.281306,-2.166204 z" />
      </svg>
      <OctagonButton
        className={toBeResponsive ? "fixedWidthButton" : ""}
        width={`calc(${width} - 33px)`}
        height={height}
        backgroundColor={backgroundColor}
        borderColor={borderColor}
      >
        {children}
      </OctagonButton>
      <svg
        className="styled-custom-button-element"
        style={{
          height:
            borderColor == NEUTRO_TITLES_COLOR ? height : (
              `calc(${height} + 1px)`
            ),
          marginTop: borderColor == NEUTRO_TITLES_COLOR ? "0px" : "-0.5px",
          fill: backgroundColor,
          stroke: borderColor && borderColor,
          marginLeft: "-1px",
        }}
        viewBox="0 0 15.763361 60"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m 4.7841623,57.225025 8.2615097,-8.160202 c 1.420463,-1.403056 2.219495,-3.313217 2.219495,-5.30587 V 16.243191 c 0,-1.992653 -0.799032,-3.902814 -2.219495,-5.305871 L 4.7841623,2.7770694 C 3.3794013,1.3894753 -0.49714374,0.61091518 -0.49714374,0.61091518 l 0.129301,31.06875382 -0.129301,27.71156 c 0,0 3.87654504,-0.778591 5.28130604,-2.166204 z" />
      </svg>
    </InlineButtonWithInteractiveStyles>
  );
};

export const CustomButtonSubmit: React.FC<CustomButtonProps> = ({
  children,
  width,
  height,
  backgroundColor,
  marginX,
  marginY,
  onClick,
  borderColor,
  marginLeft,
  toBeResponsive,
}) => {
  // TO DO: check the height of the svg and the height of the buttonm for variants
  // const getSvgHeight = (): string => {
  //   const newHeight = parseInt(height.replace("px", ""));
  //   if (
  //     width === "80px" ||
  //     width === "225px" ||
  //     width === "160px" ||
  //     width === "30px"
  //   ) {
  //     return newHeight + "px".toString();
  //   } else if (width === "165px" || width === "400px") {
  //     return newHeight + 2 + "px".toString();
  //   }
  //   return newHeight + 4 + "px".toString();
  // };
  //
  // const getSvgMargin = (): string => {
  //   if (
  //     width === "80px" ||
  //     width === "225px" ||
  //     width === "160px" ||
  //     width === "30px"
  //   ) {
  //     return "0px";
  //   } else if (width === "165px" || width === "400px") {
  //     return "-1px";
  //   } else {
  //     return "-2px";
  //   }
  // };

  return (
    <Button type={"submit"} style={{ width: "100%" }}>
      <InlineButtonWithInteractiveStyles
        className={toBeResponsive ? "whitoutMarginDiv" : ""}
        style={{ marginLeft: marginLeft && marginLeft }}
        onClick={onClick}
        width={`calc(${width} - 32px)`}
        height={height}
        backgroundColor={backgroundColor}
        marginX={marginX}
        marginY={marginY}
      >
        <svg
          className="styled-custom-button-element"
          style={{
            height:
              borderColor == NEUTRO_TITLES_COLOR ? height : (
                `calc(${height} + 1px)`
              ),
            marginTop: borderColor == NEUTRO_TITLES_COLOR ? "0px" : "-0.5px",
            fill: backgroundColor,
            stroke: borderColor && borderColor,
            marginRight: "-1px",
          }}
          viewBox="0 0 15.763361 60"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M 10.980102,57.223922 2.718592,49.06372 C 1.2981288,47.660664 0.49909699,45.750503 0.49909699,43.75785 V 16.242088 c 0,-1.992653 0.79903181,-3.902814 2.21949501,-5.305871 l 8.26151,-8.1602509 C 12.384863,1.388372 16.261408,0.60981187 16.261408,0.60981187 l -0.129301,31.06875413 0.129301,27.71156 c 0,0 -3.876545,-0.778591 -5.281306,-2.166204 z" />
        </svg>
        <OctagonButton
          className={toBeResponsive ? "fixedWidthButton" : ""}
          width={`calc(${width} - 33px)`}
          height={height}
          backgroundColor={backgroundColor}
          borderColor={borderColor}
        >
          {children}
        </OctagonButton>
        <svg
          className="styled-custom-button-element"
          style={{
            height:
              borderColor == NEUTRO_TITLES_COLOR ? height : (
                `calc(${height} + 1px)`
              ),
            marginTop: borderColor == NEUTRO_TITLES_COLOR ? "0px" : "-0.5px",
            fill: backgroundColor,
            stroke: borderColor && borderColor,
            marginLeft: "-1px",
          }}
          viewBox="0 0 15.763361 60"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m 4.7841623,57.225025 8.2615097,-8.160202 c 1.420463,-1.403056 2.219495,-3.313217 2.219495,-5.30587 V 16.243191 c 0,-1.992653 -0.799032,-3.902814 -2.219495,-5.305871 L 4.7841623,2.7770694 C 3.3794013,1.3894753 -0.49714374,0.61091518 -0.49714374,0.61091518 l 0.129301,31.06875382 -0.129301,27.71156 c 0,0 3.87654504,-0.778591 5.28130604,-2.166204 z" />
        </svg>
      </InlineButtonWithInteractiveStyles>
    </Button>
  );
};

export default CustomButton;
